import { DiagramDefinition } from "../types";

export const m019Definition: DiagramDefinition = {
  id: "M-019",
  title: "Sandboxed JSVM Globals & Execution",
  description:
    "Isolation model of JavaScript hook sandbox injecting $app proxy, console, Buffer, Date, and JSON globals while restricting dangerous Node modules.",
  viewBox: "0 0 1250 300",
  nodes: [
    { id: "A", kind: "service", label: "pb_hooks/*.js", subtext: "Hook Code", position: [100, 150], size: [130, 46] },
    { id: "B", kind: "service", label: "Node VM", subtext: "Isolated Context", position: [340, 150], size: [130, 46], statusColor: "#ff5a1f" },
    { id: "D", kind: "service", label: "Inject Globals", subtext: "Context Population", position: [580, 150], size: [130, 46] },
    
    // Globals Split
    { id: "E", kind: "service", label: "$app Proxy", subtext: "DB & Settings API", position: [820, 90], size: [140, 44] },
    { id: "F", kind: "service", label: "console / Buffer / JSON", subtext: "Standard Globals", position: [820, 210], size: [195, 50] },

    { id: "I", kind: "service", label: "Hook Execution", subtext: "Safe VM Execution", position: [1120, 150], size: [130, 46], statusColor: "#ff5a1f" },
  ],
  edges: [
    { id: "e1", source: "A", target: "B", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "B", target: "D", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e3", source: "D", target: "E", sourcePort: "right", targetPort: "left", routing: "orthogonal", midOffset: 690 },
    { id: "e4", source: "D", target: "F", sourcePort: "right", targetPort: "left", routing: "orthogonal", midOffset: 690 },
    { id: "e5", source: "E", target: "I", sourcePort: "right", targetPort: "left", routing: "orthogonal", midOffset: 980 },
    { id: "e6", source: "F", target: "I", sourcePort: "right", targetPort: "left", routing: "orthogonal", midOffset: 980 },
  ],
};
